/**
 * Подписи экранов «Публикации», «Карточка публикации» и «Журнал решений»
 * (v2). Отдельный файл от `content-labels.ts`, чтобы параллельные задачи v2
 * не правили один и тот же файл; правила те же: `Record<Union, string>` —
 * проверка полноты, тексты простые, для бизнеса.
 */
/** Откуда публикация: расписание движка или старая история (до движка). */
export const CONTENT_PUBLICATION_SOURCE_LABEL_RU = {
    scheduler: 'Движок',
    legacy: 'Старая история',
};
/** Пост в сети ещё не найден: ждём сбор статистики / не нашёлся. */
export const CONTENT_LINK_STATUS_LABEL_RU = {
    linked: 'связано',
    pending: 'не связано',
    failed: 'не связано',
};
/** Подсказка к «не связано» по статусу, если движок не назвал причину. */
export const CONTENT_LINK_STATUS_HINT_RU = {
    linked: 'Публикация связана с постом в сети.',
    pending: 'Пост ещё не найден в статистике сети — движок попробует при следующем сборе.',
    failed: 'Пост не найден в статистике сети.',
};
/** Причина выбора первого клипа цветом (как в первой админке). */
export const CONTENT_CHOICE_REASON_BADGE_VARIANT = {
    strong: 'success',
    working: 'info',
    probe: 'accent',
    override: 'warning',
    fallback: 'neutral',
};
/**
 * Почему кандидат НЕ допущен к выбору — строка движка (`excludedReason`,
 * `policy/select.ts`). Неизвестная строка показывается как есть
 * (`contentExcludedReasonRu`).
 */
export const CONTENT_EXCLUDED_REASON_LABEL_RU = {
    exclude: 'не ставить первым (вручную)',
    rest: 'отдых (вручную)',
    similarity: 'похож на недавний',
    resting: 'пауза после выхода первым',
    too_long: 'слишком длинный',
};
export function contentExcludedReasonRu(reason) {
    return CONTENT_EXCLUDED_REASON_LABEL_RU[reason] ?? reason;
}
/** Итог пробы нового клипа через 2 суток. */
export const CONTENT_PROBE_OUTCOME_LABEL_RU = {
    below: 'ниже обычного',
    neutral: 'как обычно',
    hit: 'залёт',
};
export const CONTENT_PROBE_OUTCOME_BADGE_VARIANT = {
    below: 'danger',
    neutral: 'neutral',
    hit: 'success',
};
/** Источник снимка просмотров (строка движка). */
export const CONTENT_SNAPSHOT_SOURCE_LABEL_RU = {
    metricool: 'Metricool',
    legacy: 'старые данные',
    missed: 'пропущен',
};
export function contentSnapshotSourceRu(source) {
    if (source === null)
        return '—';
    return CONTENT_SNAPSHOT_SOURCE_LABEL_RU[source] ?? source;
}
/** Вовлечённость: подписи метрик снимка. */
export const CONTENT_ENGAGEMENT_METRIC_LABEL_RU = {
    likes: 'Лайки',
    comments: 'Комментарии',
    shares: 'Репосты',
    saves: 'Сохранения',
    reach: 'Охват',
};
export const CONTENT_ENGAGEMENT_METRICS = [
    'likes',
    'comments',
    'shares',
    'saves',
    'reach',
];
/** Порог «как ожидалось»: факт отличается от ожидания меньше чем на 10 %. */
export const CONTENT_EXPECTATION_TOLERANCE = 0.1;
/**
 * Вердикт «лучше / хуже / как ожидалось» и во сколько раз. null — нет факта
 * или ожидания.
 */
export function contentExpectationVerdict(fact, expected) {
    if (fact == null || expected == null || !(fact > 0) || !(expected > 0))
        return null;
    const ratio = fact / expected;
    if (ratio >= 1 + CONTENT_EXPECTATION_TOLERANCE)
        return { verdict: 'better', ratio };
    if (ratio <= 1 / (1 + CONTENT_EXPECTATION_TOLERANCE))
        return { verdict: 'worse', ratio };
    return { verdict: 'as_expected', ratio };
}
/** Публикация не связана с постом — для таблицы и карточки. */
export const CONTENT_UNLINKED_LABEL_RU = 'не связано';
/** Период «Всё время» в фильтре публикаций и журнала. */
export const CONTENT_ALL_TIME_LABEL_RU = 'Всё время';
/** Свой период в фильтре. */
export const CONTENT_CUSTOM_PERIOD_LABEL_RU = 'Свой период';
//# sourceMappingURL=content-publications-labels.js.map